<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >ลูกค้าเริ่ม</label>
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="begin_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >ลูกค้าสุดท้าย</label>
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="end_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกสาขา</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
                @change="onSelectBranch(branch)"
              >
                <option value="0">-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                >{{ b.branch_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >จากวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >ถึงวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_sale_type.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                class="btn btn-primary btn-block"
              >
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_sale_type.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
        </div>
        <div
          class="text-center pt-3"
          v-if="report_data.length < 1"
        >
          <h5>ไม่มีข้อมูล</h5>
        </div>
        <div class="table-responsive-sm mt-3">
          <table
            id="sendMoney"
            colspan="6"
            class="table table-bordered"
            v-for="(c, i) in report_data"
            :key="'c' + i"
            v-show="c.doc.length > 0"
          >
            <thead>
              <tr style="background: #fffed4;">
                <th colspan="7">
                  <h4 class="m-1">สาขา: {{ c.branch_name }}</h4>
                </th>
              </tr>
              <tr
                class="text-center"
                style="background: #ebf6ff;"
              >
                <th>วันที่</th>
                <th>เลขที่เอกสาร</th>
                <th>ลูกค้า</th>
                <th>เงินสด</th>
                <th>เงินโอน</th>
                <th>ยอดขายสุทธิ</th>
                <th>หมายเหตุ</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(d, i) in c.doc[0].sales"
                :key="'d' + i"
              >
                <td class="text-center">{{ dateFormatAndTime(d.create_time) }}</td>
                <td class="text-center">{{ d.doc_no }}</td>
                <td class="text-left">{{ d.ar_code || '-' }}: {{ d.ar_name || '-' }}</td>
                <td class="text-right">{{ numberFormatDecimal(d.cash_amount) }}</td>
                <td class="text-right">{{ numberFormatDecimal(d.bank_amount) }}</td>
                <td class="text-right">{{ numberFormatDecimal(d.total_amount) }}</td>
                <td class="text-left">{{ d.my_description || '-' }}</td>
              </tr>
              <tr style="background: #cccccc;">
                <th
                  colspan="3"
                  class="text-left"
                >รวมสาขา</th>
                <th class="text-right">{{ numberFormatDecimal(c.doc[0].sum_cash_amount) }}</th>
                <th class="text-right">{{ numberFormatDecimal(c.doc[0].sum_bank_amount) }}</th>
                <th class="text-right">{{ numberFormatDecimal(c.doc[0].sum_total_amount) }}</th>
                <th></th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <table
        style="width: 98%; margin: 1%;"
        v-if="calAmountCash(report_data) > 0"
      >
        <tr style="background: #eeffeb; ">
          <th
            style="text-align: left;"
            class="pt-2 pl-2 pb-0"
          >
            <h5>รวมทุกสาขา</h5>
          </th>
          <th class="text-right">เงินสด: {{ numberFormatDecimal(calAmountCash(report_data)) }} บาท</th>
          <th class="text-right">เงินโอน: {{ numberFormatDecimal(calAmountBank(report_data)) }} บาท</th>
          <th class="text-right">รวมสุทธิ: {{ numberFormatDecimal(calAmountTotal(report_data)) }} บาท</th>
        </tr>
      </table>
    </div>
  </section>
</template>


<script>
/* eslint-disable */
import moment from 'moment'
import api from '../services/service_report'
import apipos from '../services/service_pos'
import apiCus from '@/services/service_customer'

export default {
  data () {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: '',
      end_code: '',
      dyn_address: ''
    }
  },
  methods: {
    onSelectBranch (val) {
      console.log(val)
      this.dyn_address = val.dyn_address
      this.getCus()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getReport () {
      var branch = 0
      this.report_data = []
      this.form_data = ''
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        id: branch,
        begin_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate),
        // begin_date: '2020-08-01',
        // end_date: '2020-09-01',
        company_id: 1,
        branch_id: 1,
        // begin_code: '0236',
        // end_code: '0236',
        begin_code: this.begin_code,
        end_code: this.end_code,
        keyword: ''
      }
      this.$store.state.isLoading = true
      api.saleType(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          if (result.response === 'success') {
            this.report_data = result.data
            console.log(this.report_data, this.report_data.length)
            this.form_data = JSON.stringify(this.report_data)
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            this.$store.state.isLoading = false
            // this.getReport()
          } else {
            this.$store.state.isLoading = false
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          this.$store.state.isLoading = false
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    calAmountCash (obj) {
      var total = 0
      obj.forEach(v => {
        v['doc'].forEach(val => {
          total += val['sum_cash_amount']
        })
      })
      return total
    },
    calAmountBank (obj) {
      var total = 0
      obj.forEach(v => {
        v['doc'].forEach(val => {
          total += val['sum_bank_amount']
        })
      })
      return total
    },
    calAmountTotal (obj) {
      var total = 0
      obj.forEach(v => {
        v['doc'].forEach(val => {
          total += val['sum_total_amount']
        })
      })
      return total
    },
    capEnter () {
      $('a').on('keyup', function (e) {
        if (e.which == 13) {
          console.log(e.target.href)
        }
      })
    },
    getCus () {
      this.$store.state.isLoading = true
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      apiCus.listAll(
        this.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        // this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.data_cus_list = result.data
            this.$store.state.isLoading = false
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลลูกค้า', result.message)
            this.$store.state.isLoading = false
          }
        },
        error => {
          this.$store.state.isLoading = false
          this.alert_msg('warning', 'ดึงข้อมูลลูกค้า', error.message)
        }
      )
    },
  },
  mounted () {
    this.checkUser()
    this.getHost()
    this.getBranch()
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0]
      this.dyn_address = this.$store.state.branch_list[0].dyn_address
      this.getCus()
    }, 500)
  }
}
</script>
<style scoped>
.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.table .thead-dark th {
  color: #000000;
  background-color: #ffffad;
  border-color: #ffffad;
}
.table .thead-footer th {
  color: #000000;
  text-align: center;
  background-color: #ffff;
}
#sendMoney .table tr,
.table td,
.table th {
  padding: 0 5px;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/views/reportsaletype.vue